import { createFileRoute } from '@tanstack/react-router'
import { DeliveryRequestList } from '@/features/dashboard/delivery-request/DeliveryRequestList'

export const Route = createFileRoute('/_dashboard/delivery-requests/')({
  component: DeliveryRequestListPage,
})

function DeliveryRequestListPage() {
  return <DeliveryRequestList />
}
